import {
  fetchOperation,
  putOperation,
  getOperation,
  getMaster,
} from "utils/api";

export const queryAgentDetail = async (isoAgentId) => {
  return await getOperation("/agent", { isoAgentId: isoAgentId });
};

export const queryAgentMerchant = async (params) => {
  return await getOperation("/merchant/list", {
    sort: "createdDate,desc",
    ...params,
  });
};

export const resetPassword = async (params) => {
  return await fetchOperation("/admin/reset/password", {
    ...params,
  });
};

export const updateStatus = async (params) => {
  return await putOperation("/agent", {
    ...params,
  });
};

export const getSuspensionRemarks = async () => {
  return await getOperation("/account-management/remarks");
};

export const getRoleList = async (params) => {
  return await getMaster("/roles", {
    sort: "created_date,desc",
    ...params,
  });
};
